function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { SVG } from '@svgdotjs/svg.js';
import { device } from '../helpers';
import debounce from 'lodash/debounce';
var SearchTower = /*#__PURE__*/ function() {
    "use strict";
    function SearchTower() {
        _class_call_check(this, SearchTower);
        _define_property(this, "api", api.floor);
        _define_property(this, "data", towerData);
        _define_property(this, "floorPath", []);
        _define_property(this, "$els", {
            plan: document.querySelector('[data-tower-plan]'),
            desc: document.querySelector('[data-tower-description]'),
            floor: {
                number: document.querySelector('[data-floor-number]'),
                sections: document.querySelector('[data-floor-sections]'),
                sectionItem: document.querySelectorAll('[data-floor-section-item]'),
                schema: document.getElementById('floor'),
                sliderTower: document.querySelector('[data-tower-slider]'),
                slider: document.querySelector('[data-floor-slider]'),
                slidesControls: document.querySelectorAll('[data-floor-id]'),
                mini: document.querySelector('[data-tower-mini]')
            }
        });
        _define_property(this, "towerDraw", null);
        _define_property(this, "sectionDraw", null);
        _define_property(this, "sectionData", null);
        _define_property(this, "floorSection", "a");
    }
    _create_class(SearchTower, [
        {
            key: "handleCreateSection",
            value: function handleCreateSection() {
                var _this = this;
                this.$els.floor.schema.innerHTML = '';
                console.log(this.sectionData);
                this.sectionDraw = SVG().addTo(this.$els.floor.schema);
                var sectionsBg = [];
                this.sectionData[this.floorSection].rooms.forEach(function(room) {
                    var color = '#8399B7';
                    if (room.status === 'reserve') color = '#D3BB89';
                    if (room.status === 'sold') color = '#DCDCDC';
                    sectionsBg.push(_this.sectionDraw.path(room.path).css({
                        fill: color,
                        opacity: 0.5
                    }));
                });
                var plan = this.sectionDraw.image(this.sectionData[this.floorSection].image, function(event) {
                    if ("".concat(_this.sectionData[_this.floorSection].image).match(/\.svg$/)) {
                        fetch(_this.sectionData[_this.floorSection].image).then(function(res) {
                            return res.text();
                        }).then(function(res) {
                            var width;
                            var height;
                            var viewBoxMatch = res.match(/viewBox="([^"]+)"/);
                            if (viewBoxMatch) {
                                var _viewBoxMatch__split = _sliced_to_array(viewBoxMatch[1].split(' '), 4), viewBoxWidth = _viewBoxMatch__split[2], viewBoxHeight = _viewBoxMatch__split[3];
                                width = viewBoxWidth;
                                height = viewBoxHeight;
                            } else {
                                var _res_match = _sliced_to_array(res.match(/width="(\d+)"/), 2), attrWidth = _res_match[1];
                                var _res_match1 = _sliced_to_array(res.match(/height="(\d+)"/), 2), attrHeight = _res_match1[1];
                                width = attrWidth;
                                height = attrHeight;
                            }
                            _this.sectionDraw.viewbox(0, 0, width, height);
                            plan.width(width);
                            plan.height(height);
                        });
                    } else {
                        var _ref = event.target || (event === null || event === void 0 ? void 0 : event.path[0]), naturalWidth = _ref.naturalWidth, naturalHeight = _ref.naturalHeight;
                        _this.sectionDraw.viewbox(0, 0, naturalWidth, naturalHeight);
                        plan.width(naturalWidth);
                        plan.height(naturalHeight);
                    }
                });
                this.sectionData[this.floorSection].rooms.forEach(function(room, index) {
                    var area = _this.sectionDraw.path(room.path).css({
                        fill: 'rgba(0, 0, 0, 0)',
                        cursor: room.status === 'free' ? 'pointer' : 'default'
                    });
                    if (room.status === 'sold' || room.status === 'reserve') {
                        var timeout = setTimeout(function() {
                            var LABEL_SOLD_WIDTH = 140;
                            var LABEL_RESERVED_WIDTH = 106;
                            var LABEL_HEIGHT = 50;
                            var x;
                            var y;
                            if (room.position) {
                                x = room.position.x;
                                y = room.position.y;
                            } else {
                                var sizes = sectionsBg[index].node.getBBox();
                                x = sizes.width > 0 && sizes.height > 0 ? sizes.x + sizes.width / 2 : -10000;
                                y = sizes.width > 0 && sizes.height > 0 ? sizes.y + sizes.height / 2 : -10000;
                            }
                            var label = _this.sectionDraw.rect(room.status === 'sold' ? LABEL_SOLD_WIDTH : LABEL_RESERVED_WIDTH, LABEL_HEIGHT);
                            label.move(x - (room.status === 'sold' ? LABEL_SOLD_WIDTH / 2 : LABEL_RESERVED_WIDTH / 2), y - LABEL_HEIGHT / 2);
                            label.css({
                                fill: '#fff'
                            });
                            label.rx(10);
                            var text = _this.sectionDraw.text(room.status === 'sold' ? 'Продано' : 'Бронь');
                            text.font({
                                leading: 1,
                                size: 28,
                                weight: 'bold'
                            });
                            var sizesText = text.node.getBBox();
                            text.move(x - sizesText.width / 2, y - sizesText.height / 2);
                            clearTimeout(timeout);
                        }, 1000);
                    }
                    if (!device.isTouch() && room.status === 'free') {
                        area.on('mouseenter', function() {
                            sectionsBg[index].animate({
                                duration: 150,
                                when: 'relative'
                            }).css({
                                opacity: 1
                            });
                        }).on('mouseleave', function() {
                            sectionsBg[index].animate({
                                duration: 150,
                                when: 'relative'
                            }).css({
                                opacity: 0.5
                            });
                        });
                    }
                    if (room.status === 'free' && room.href) {
                        area.on('click', function() {
                            window.open(room.href + "?floor", '_blank');
                        });
                    }
                });
            }
        },
        {
            key: "handleFloorClear",
            value: function handleFloorClear() {
                var _this_$els_floor_mini_querySelector;
                this.$els.floor.number.innerText = '';
                this.$els.floor.sectionItem.forEach(function($item) {
                    $item.checked = false;
                    $item.disabled = true;
                });
                var slideCurrent = document.querySelector('.swiper-slide-current');
                if (slideCurrent) slideCurrent.classList.remove('swiper-slide-current');
                (_this_$els_floor_mini_querySelector = this.$els.floor.mini.querySelector('.rooms-mini__area_active')) === null || _this_$els_floor_mini_querySelector === void 0 ? void 0 : _this_$els_floor_mini_querySelector.classList.remove('rooms-mini__area_active');
                this.$els.floor.schema.innerHTML = '';
                this.sectionDraw = null;
                this.sectionData = null;
            }
        },
        {
            key: "handleCreateFloor",
            value: function handleCreateFloor(floorData) {
                var _this = this;
                var fromTower = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this_data_floors_find;
                this.handleFloorClear();
                var floorID = (_this_data_floors_find = this.data.floors.find(function(item) {
                    return item.number.toString() === floorData.number.toString();
                })) === null || _this_data_floors_find === void 0 ? void 0 : _this_data_floors_find.id;
                var sections = Object.keys(floorData.sections);
                if (fromTower) {
                    this.floorSection = sections.includes(floorData.defaultSection) ? floorData.defaultSection : sections.find(function(item) {
                        return item !== floorData.defaultSection;
                    });
                } else if (!sections.includes(this.floorSection)) {
                    this.floorSection = sections.find(function(item) {
                        return item !== _this.floorSection;
                    });
                }
                this.$els.floor.number.innerText = floorData.number;
                var slides = this.$els.floor.slider.querySelectorAll('.swiper-slide');
                var slideIndex = Array.from(slides).findIndex(function(item) {
                    return item.querySelector('button').innerText === floorData.number;
                });
                slides[slideIndex].classList.add('swiper-slide-current');
                window.floorSlider.slideTo(slideIndex - 5, 0);
                this.$els.floor.mini.querySelector('[id="id'.concat(floorID, '"]')).classList.add('rooms-mini__area_active');
                console.log(floorData);
                this.sectionData = floorData.sections;
                this.$els.floor.sectionItem.forEach(function($item) {
                    $item.checked = $item.value === _this.floorSection;
                    $item.disabled = !sections.includes($item.value);
                });
                this.handleCreateSection();
            }
        },
        {
            key: "handleDrawMainImage",
            value: function handleDrawMainImage() {
                var _this = this;
                var image = this.data.image;
                this.towerDraw = SVG().addTo(this.$els.plan);
                this.towerDraw.image(image, function(event) {
                    var _ref = event.target || (event === null || event === void 0 ? void 0 : event.path[0]), naturalWidth = _ref.naturalWidth, naturalHeight = _ref.naturalHeight;
                    _this.towerDraw.viewbox(0, 0, naturalWidth, naturalHeight);
                });
            }
        },
        {
            key: "handleFloorResponse",
            value: function handleFloorResponse(id) {
                var _this = this;
                var fromTower = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                console.log(id, "111");
                var $floorTab = document.querySelector('[data-room-tab="floor"]');
                console.log("".concat(this.api, "?id=").concat(id));
                $floorTab.classList.add('-loading');
                window.searchTab('floor');
                fetch("".concat(this.api, "?id=").concat(id)).then(function(response) {
                    return response.json();
                }).then(function(response) {
                    console.log(response);
                    _this.handleCreateFloor(response, fromTower);
                    $floorTab.classList.remove('-loading');
                });
            }
        },
        {
            key: "handleDrawFloors",
            value: function handleDrawFloors() {
                var _this = this;
                var floors = this.data.floors;
                var activeDefault = floors.findIndex(function(item) {
                    return item.number === parseInt(_this.$els.floor.sliderTower.dataset.towerFloorStart);
                }) || 0;
                floors.forEach(function(floor, index) {
                    var level = _this.towerDraw.path(floor.path).css({
                        fill: '#141414',
                        opacity: index === activeDefault ? '.5' : '0',
                        cursor: 'pointer'
                    });
                    level.node.id = "f".concat(floor.number);
                    _this.floorPath.push(level);
                    var activeSlide = Array.from(_this.$els.floor.sliderTower.querySelectorAll('[data-tower-floor-id]')).findIndex(function(item) {
                        return item.innerText === floor.number.toString();
                    });
                    if (!device.isTouch()) {
                        level.on('mouseenter', function() {
                            if (window.innerWidth > 1440) {
                                window.towerSlider.slideTo(activeSlide, 0);
                            }
                        });
                    }
                    level.on('click', function() {
                        if (window.innerWidth > 1440) {
                            _this.handleFloorResponse(floor.id, true);
                        } else {
                            window.towerSlider.slideTo(activeSlide, 0);
                        }
                    });
                });
            }
        },
        {
            key: "init",
            value: function init() {
                var _this = this;
                var _this_$els_floor_mini_querySelectorAll;
                var floors = this.data.floors;
                this.handleDrawMainImage();
                this.handleDrawFloors();
                if (window.location.href.includes("#apartment?floor")) {
                    var href = window.location.href;
                    console.log(window.location.href.split("-")[1]);
                    this.handleFloorResponse(window.location.href.split("-")[1], true);
                }
                window.towerSlider.on('slideChange', function(event) {
                    var floor = window.towerSlider.slides[event.activeIndex].innerText;
                    _this.floorPath.forEach(function(item) {
                        item.animate({
                            duration: 150,
                            when: 'relative'
                        }).css({
                            opacity: item.node.id.substring(1) === floor ? '.5' : '0'
                        });
                    });
                    _this.$els.desc.classList.add('tower-numbers_hide');
                });
                window.towerSlider.on('slideChange', debounce(function(event) {
                    var floor = window.towerSlider.slides[event.activeIndex].innerText;
                    var floorData = floors.find(function(item) {
                        return item.number === parseInt(floor);
                    });
                    var timeout = setTimeout(function() {
                        _this.$els.desc.innerHTML = "\n						".concat(floorData.descriptions.map(function(item) {
                            return '\n									<div class="tower-numbers__item">\n										<div class="tower-numbers__value">'.concat(item.value, '</div>\n										<div class="tower-numbers__label">').concat(item.label, "</div>\n									</div>\n								");
                        }).join(''), '\n						<button class="button button_inline tower-numbers__control" data-tower-description-more="').concat(floorData.id, '">\n							<span>подробнее</span>\n						</button>\n					');
                        _this.$els.desc.classList.remove('tower-numbers_hide');
                        clearTimeout(timeout);
                    }, 250);
                }, 250));
                document.addEventListener('click', function(event) {
                    var $el = event.target;
                    if ($el.dataset.towerDescriptionMore !== undefined) {
                        _this.handleFloorResponse($el.dataset.towerDescriptionMore, true);
                    }
                });
                this.$els.floor.slidesControls.forEach(function($item) {
                    $item.addEventListener('click', function(event) {
                        event.preventDefault();
                        _this.handleFloorResponse($item.dataset.floorId);
                    });
                });
                (_this_$els_floor_mini_querySelectorAll = this.$els.floor.mini.querySelectorAll('.rooms-mini__area')) === null || _this_$els_floor_mini_querySelectorAll === void 0 ? void 0 : _this_$els_floor_mini_querySelectorAll.forEach(function($item) {
                    $item.addEventListener('click', function() {
                        _this.handleFloorResponse($item.id.substring(2));
                    });
                });
                this.$els.floor.sectionItem.forEach(function($item) {
                    $item.addEventListener('change', function(event) {
                        _this.floorSection = event.target.value;
                        _this.handleCreateSection();
                    });
                });
            }
        }
    ]);
    return SearchTower;
}();
export default SearchTower;
